// tslint:disable: no-implicit-dependencies
import * as React from 'react';
import * as styles from './AreaParts.css';
import { Link } from '../../../common/Link';

export const AreaParts = () => (
  <div className={styles['wrapper']}>
    <div className={styles['title']}>Объявление частями</div>
    <div>
      Вы&nbsp;указали площадь с&nbsp;возможностью аренды частями.
      Для такого типа объявлений действуют специальные
      {' '}
      <Link href="https://www.cian.ru/price/?from=footer" target="_blank">
        тарифы размещения
      </Link>
    </div>
  </div>
);
